<template>
    <div class="xc-page">

        <!-- 分栏布局 -->
        <div class="xc-page-main">
          <!-- 面包屑 -->
          <div class="xc-breadcrumb">
            <router-link :to="$config.adminPath + '/device/state/statistic'">报表统计</router-link>
            <a>在线统计</a>
          </div>
          <div class="xc-row xc-s-flex">
              <div class="xc-col xc-col-first">
                  <div class="xc-card">
                      <div class="xc-card-header">
                          <div class="xc-card-title">近7天设备在线、离线趋势</div>
                          <div class="legend">
                            <div class="legend-item">
                              <span class="icon" style="background-color: #4bba5a"></span>
                              <span>在线</span>
                            </div>
                            <div class="legend-item">
                              <span class="icon" style="background-color: #f75c78"></span>
                              <span>离线</span>
                            </div>
                          </div>
                      </div>
                      <div class="xc-card-content">
                        <div id="device-chart"></div>
                      </div>
                  </div>
              </div>
              <div class="xc-col">
                  <div class="xc-card">
                      <div class="xc-card-header">
                          <div class="xc-card-title">近7天单个终端节目下载趋势</div>
                          <div class="legend">
                            <div class="legend-item">
                              <span class="icon" style="background-color: #805CF0"></span>
                              <span>下载数量</span>
                            </div>
                          </div>
                      </div>
                      <div class="xc-card-content">
                        <div id="download-chart"></div>
                      </div>
                  </div>
              </div>
          </div>
        </div>

        <!-- <div class="xc-page-footer">
        </div> -->
    </div>
</template>

<script>
import G2 from "@antv/g2";
import DataSet from "@antv/data-set";
import reportFormApi from "../api/report-forms";

export default {
  name: 'pageFullCol',

  data() {
    return {
      // 初始化单设备近7天客流人数
      listSummarizeRecentSevenDTO: [
        {
            "date": "3-15",               //日期
            "peopleNumSum": 1100           //人数
        },{
            "date": "3-16",
            "peopleNumSum": 2000
        },{
            "date": "3-17",
            "peopleNumSum": 900
        },{
            "date": "3-18",
            "peopleNumSum": 3300
        },{
            "date": "3-19",
            "peopleNumSum": 3000
        },{
            "date": "3-20",
            "peopleNumSum": 4000
        },{
            "date": "3-31",
            "peopleNumSum": 2800
        }
      ],

      // 初始化单广告近7天每小时平均：观看人次&触达人次
      listMonitorWatchTouch:[{
      }],

      maxData: 100,
    }
  },

  async mounted() {
    let that = this
    // 近7天终端在线离线数量
    reportFormApi.sevenDeviceLineInfo().then(v => {
        let list = v.data
        for (let item of list) {
          item.markDate = (item.markDate).slice(5)
        }
        that.createDeviceChart(that.det(list).reverse())
    })

    // 近7天单个终端节目下载趋势
    reportFormApi.getProgramDownloadNum().then(v => {
        let list = v.data
        for (let item of list) {
          item.time = (item.time).slice(5)
        }
        that.createDeviceDownloadChart(list.reverse())
    })
  },

  methods: {

    // 处理数据方法
    det(data) {
      data = JSON.parse(JSON.stringify(data).replace(/totalOnline/g,"在线数量"));
      data = JSON.parse(JSON.stringify(data).replace(/totalOffline/g,"离线数量"));
      return data
    },

    // 近7天终端在线离线数量
    createDeviceChart(data) {
      var ds = new DataSet();
      var dv = ds.createView().source(data);
      // fold 方式完成了行列转换，如果不想使用 DataSet 直接手工转换数据即可
      dv.transform({
        type: 'fold',
        fields: ['在线数量', '离线数量'], // 展开字段集
        key: 'city', // key字段
        value: 'temperature' // value字段
      });
      var chart = new G2.Chart({
        container: 'device-chart',
        forceFit: true,
        height: window.innerHeight * 0.31,
        padding: [20, 30, 25, 40]
      });
      chart.source(dv, {
        markDate: {
          type: 'cat',
        },
      });
      chart.tooltip({
        crosshairs: {
          type: 'line'
        }
      });
      chart.axis("markDate", {
        line: {
          // 设置线的颜色
          stroke: "#d8e1f2",
          lineStyle: {
            lineWidth: 4
          }
        },
        grid: {
          // 网格
          type: "line",
          lineStyle: {
            stroke: "#d8e1f2",
            lineWidth: 0.5
          }
        },
        label: {
          textStyle: {
            fill: "#6e7a90"
          }
        },
        tickLine: {
          alignWithLabel: "center",
          length: 0
        },
      });

      chart.axis('temperature', {
        label: {
          formatter: function formatter(val) {
            return val;
          },
          textStyle: {
            fill: "#6e7a90"
          }
        },
        line: {
          // 设置线的颜色
          stroke: "#d8e1f2"
        },
        grid: {
          // 网格
          type: "line",
          lineStyle: {
            stroke: "#d8e1f2",
            lineWidth: 0.3,
            lineDash: [0, 0 ] // 网格线的虚线配置，第一个参数描述虚线的实部占多少像素，第二个参数描述虚线的虚部占多少像素
          }
        },
      });
      chart.line().position('markDate*temperature').color('city', ["#4bba5a", "#f75c78"]).shape('smooth').style({
          lineWidth: 4
        });
      chart.point().position('markDate*temperature').color('city', ["#4bba5a", "#f75c78"]).size(4).shape('circle').style({
        stroke: '#fff',
        lineWidth: 1
      });
      chart.render();
    },


    // 近7天单个终端节目下载趋势
    createDeviceDownloadChart(data) {
      var chart = new G2.Chart({
        container: "download-chart",
        forceFit: true,
        height: window.innerHeight * 0.31,
        padding: [20, 30, 25, 40]
      });
      chart.source(data, {
        time: {
          type: 'cat',
        },
      });
      chart.scale("downloadNum", {
        alias: "下载数量",
        min: 0,
        // max: this.maxData,
        // tickCount: 9
      });
      chart.tooltip({
        crosshairs: {
          type: "line"
        }
      });
      chart.axis("downloadNum", {
        line: {
          // 设置线的颜色
          stroke: "#d8e1f2",
        },
        grid: {
          // 网格
          type: "line",
          lineStyle: {
            stroke: "#d8e1f2",
            lineWidth: 0.3,
            lineDash: [4, 0 ] // 网格线的虚线配置，第一个参数描述虚线的实部占多少像素，第二个参数描述虚线的虚部占多少像素
          }
        },
        label: {
          textStyle: {
            fill: "#6e7a90"
          }
        }
      });
      chart.axis("time", {
        line: {
          // 设置线的颜色
          stroke: "#d8e1f2"
        },
        grid: {
          // 网格
          type: "line",
          lineStyle: {
            stroke: "#d8e1f2",
            lineWidth: 0.3
          }
        },
        label: {
          textStyle: {
            fill: "#6e7a90"
          }
        },
        tickLine: {
          alignWithLabel: true,
          length: 0
        }
      });
      chart
        .line()
        .position("time*downloadNum")
        .shape("smooth")
        .color("#805CF0")
        .style({
          lineWidth: 4
        });
      chart
        .point()
        .position("time*downloadNum")
        .size(4)
        .shape("circle")
        .color("#805CF0")
        .style({
          stroke: "#fff",
          lineWidth: 0.8
        });
      chart.render();
    },
  }
}
</script>

<style scoped lang="scss">
.xc-card-content {
  overflow: hidden;
}
.xc-col-first {
  margin-right: 0;
  margin-bottom: 20px;
}
.xc-s-flex {
  flex-direction: column;
}

.legend {
  display: flex;
  margin-right: 6px;
}
.legend-item {
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-right: 10px;
  .icon {
    width: 10px;
    height: 10px;
    background: #00CFCD;
    border-radius: 7px;
    margin-right: 4px;
  }
}
.legend-item:last-child {
  margin-right: 0;
}

.xc-home-container .xc-home-content .xc-page-main > .xc-row:last-child {
    padding-bottom: 0rem;
}
</style>

